/** Temas prontos: paleta + ornamento + tipografia + escrita já combinados. */
export const TEMAS = [
    {
        id: 'aurora',
        nome: 'Aurora',
        descricao: 'Azul profundo com destaque coral. Clássico editorial, funciona em qualquer contexto.',
        corPrincipal: '#1F4E79',
        esquema: 'COMPLEMENTAR_DIVIDIDO',
        intensidadeFundo: 0.4,
        ornamento: 'LINHA_FINA',
        tipografia: 'MISTA',
        assinatura: 'Um dia de cada vez.',
    },
    {
        id: 'oceano',
        nome: 'Oceano',
        descricao: 'Turquesa analógico: calmo e arejado, ideal para rotinas longas.',
        corPrincipal: '#0E7C86',
        esquema: 'ANALOGO',
        intensidadeFundo: 0.45,
        ornamento: 'ARCO',
        tipografia: 'SANS',
        assinatura: 'Respire. Siga o fluxo.',
    },
    {
        id: 'terracota',
        nome: 'Terracota',
        descricao: 'Barro quente com toque esverdeado. Acolhedor e artesanal.',
        corPrincipal: '#B4552D',
        esquema: 'COMPLEMENTAR',
        intensidadeFundo: 0.5,
        ornamento: 'FLORAL',
        tipografia: 'SERIFA',
        assinatura: 'Feito à mão, no seu tempo.',
    },
    {
        id: 'floresta',
        nome: 'Floresta',
        descricao: 'Verde-escuro monocromático. Sóbrio, perfeito para planejamento de trabalho.',
        corPrincipal: '#2F5D3A',
        esquema: 'MONOCROMATICO',
        intensidadeFundo: 0.35,
        ornamento: 'CANTO',
        tipografia: 'SERIFA',
        assinatura: 'Cresça um pouco por dia.',
    },
    {
        id: 'lavanda',
        nome: 'Lavanda',
        descricao: 'Lilás suave com violeta de destaque. Delicado e criativo.',
        corPrincipal: '#7A6BB5',
        esquema: 'TRIADE',
        intensidadeFundo: 0.55,
        ornamento: 'ARCO',
        tipografia: 'MISTA',
        assinatura: 'Ideias também precisam de espaço.',
    },
    {
        id: 'grafite',
        nome: 'Grafite',
        descricao: 'Cinza grafite com um fio de azul. Minimalista e corporativo.',
        corPrincipal: '#3A4149',
        esquema: 'ANALOGO',
        intensidadeFundo: 0.25,
        ornamento: 'LINHA_FINA',
        tipografia: 'SANS',
        assinatura: 'Menos ruído, mais foco.',
    },
    {
        id: 'areia',
        nome: 'Areia',
        descricao: 'Bege quente com terracota. Neutro sofisticado para bullet journal.',
        corPrincipal: '#A9834F',
        esquema: 'COMPLEMENTAR_DIVIDIDO',
        intensidadeFundo: 0.6,
        ornamento: 'GEOMETRICO',
        tipografia: 'MISTA',
        assinatura: 'Simples é suficiente.',
    },
    {
        id: 'vinho',
        nome: 'Vinho',
        descricao: 'Bordô com verde-musgo complementar. Sofisticado e marcante.',
        corPrincipal: '#7B2233',
        esquema: 'COMPLEMENTAR',
        intensidadeFundo: 0.45,
        ornamento: 'FLORAL',
        tipografia: 'SERIFA',
        assinatura: 'Elegância está nos detalhes.',
    },
    {
        id: 'menta',
        nome: 'Menta',
        descricao: 'Verde-claro luminoso com destaque cítrico. Leve e produtivo.',
        corPrincipal: '#3FA88A',
        esquema: 'TRIADE',
        intensidadeFundo: 0.5,
        ornamento: 'CANTO',
        tipografia: 'SANS',
        assinatura: 'Comece leve, termine forte.',
    },
    {
        id: 'meia-noite',
        nome: 'Meia-noite',
        descricao: 'Azul-noite com laivos de ouro. Dramático, para capas e divisórias.',
        corPrincipal: '#1B2440',
        esquema: 'TETRADE',
        intensidadeFundo: 0.3,
        ornamento: 'GEOMETRICO',
        tipografia: 'MISTA',
        assinatura: 'Planeje no silêncio.',
    },
    {
        id: 'papel-antigo',
        nome: 'Papel antigo',
        descricao: 'Ocre envelhecido com tom de linho. Nostálgico e literário.',
        corPrincipal: '#8A6A3B',
        esquema: 'ANALOGO',
        intensidadeFundo: 0.75,
        ornamento: 'CANTO',
        tipografia: 'SERIFA',
        assinatura: 'Escrever é lembrar duas vezes.',
    },
    {
        id: 'coral-vivo',
        nome: 'Coral vivo',
        descricao: 'Coral saturado com azul-petróleo. Alegre, ótimo para metas e hábitos.',
        corPrincipal: '#E2503F',
        esquema: 'COMPLEMENTAR_DIVIDIDO',
        intensidadeFundo: 0.4,
        ornamento: 'GEOMETRICO',
        tipografia: 'SANS',
        assinatura: 'Hoje conta.',
    },
];
export const TEMA_PERSONALIZADO = 'PERSONALIZADO';
export function obterTema(id) {
    return TEMAS.find((tema) => tema.id === id);
}
export function temasPorClima() {
    const matizDe = (hex) => Number.parseInt(hex.slice(1, 3), 16);
    return {
        quentes: TEMAS.filter((t) => {
            const h = matizDe(t.corPrincipal);
            return h < 60 || h > 330;
        }),
        frios: TEMAS.filter((t) => {
            const h = matizDe(t.corPrincipal);
            return h > 140 && h < 300;
        }),
        neutros: TEMAS.filter((t) => {
            const h = matizDe(t.corPrincipal);
            return (h >= 60 && h <= 140) || (h >= 300 && h <= 330);
        }),
    };
}
//# sourceMappingURL=temas.js.map